import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import SignInInput from "../../../common/SigninInput/signinInput";
import styles from "../offlinePay.module.css"
import CommonButton from "../../CommonButton/CommonButton";
import { useMyContext } from "../../../myContext";
import { onBoardOfflinePersonalDetail } from "../../../api";

function OfflineRemitterForm({stepToShowOffline, setStepToShowOffline, remitterList, documentUploaded, remitterDetail}) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  const [panError, setPanError] = useState("");
  const [nextSectionError, setNextSectionError] = useState("");
  const [loading, setLoading] = useState("");
  const [valid, setIsValid] = useState({
    name: false,
    email: false,
    phoneNumber: false,
    panNumber: false,
  });
  const {setRemitterOfflineDetail, setOfflineRemitterUserId} = useMyContext();


  useEffect(() => {
    if(remitterList.length > 0){
      setName(remitterDetail.fullName);
      setEmail(remitterDetail.email);
      let phoneNo = remitterDetail.phone || "";  
      const lastTenDigits = phoneNo.length >= 10 ? phoneNo.slice(-10) : phoneNo;       
      setPhoneNumber(Number(lastTenDigits))
      setPanNumber(remitterDetail.panNo)
      if(remitterDetail.fullName === undefined || remitterDetail.email === undefined || remitterDetail.phone === undefined || remitterDetail.panNo === undefined || remitterDetail.fullName === "" || remitterDetail.email === "" || remitterDetail.phone === "" || remitterDetail.panNo === ""){
        setNextSectionError("Please contact shreyan@stockal.com. Seems like some details are missing. Please create a new user or contact support.")
      }
    }
  },[remitterList])


  const ValidateEmail = (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setEmailError("");
      return false;
    } else {
      return true;
    }
  };

  const validatePan = (panNumber) => {
    const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    if (panPattern.test(panNumber)) {
      return true;
    } else {
      return false;
    }
  };

  const handleSuccess = () => {
    if(nextSectionError === ""){
      if(!documentUploaded){
        setStepToShowOffline(2);
      } else{
        setStepToShowOffline(3);
      }
      setRemitterOfflineDetail({
        name: name,
        phone: phoneNumber,
        email: email,
        pan: panNumber
      });
    } 
  }

  const remitterPersonalDetailApi = () => {
    setLoading(true);
    const remitterPersonalDetailData = async () => {
      const body = {
        name: name,
        email: email,
        phone: "+91" + phoneNumber,
        panNo: panNumber,
        accountType: "remitter",
      };
      try {
        onBoardOfflinePersonalDetail(body).then((resp) => {
          setLoading(false);
          if (resp.status === 200 && resp.data && resp.data.data) {
            handleSuccess();
            setOfflineRemitterUserId(resp?.data?.data?.userAccountId);
          } else {
            setNextSectionError(
              resp && resp.data
                ? resp.data.message
                : "something went wrong, please try again later."
            );
          }
        });
      } catch (error) {
        setLoading(false);
        setNextSectionError("something went wrong, please try again later.");
      }
    };
    remitterPersonalDetailData();
  };

  const checkIfValid = () => {
    if (name === "") {
      setIsValid({ ...valid, name: true });
    } else if (email === "") {
      setIsValid({ ...valid, email: true });
    } else if (phoneNumber === "") {
      setIsValid({ ...valid, phoneNumber: true });
    } else if (panNumber === "") {
      setIsValid({ ...valid, panNumber: true });
    } else if (
      emailError !== "" ||
      phoneNoError !== "" ||
      panError !== ""
    ) {
      setNextSectionError("Please fill all the required field correctly.");
    } else {
      setIsValid({
        name: false,
        email: false,
        phoneNumber: false,
        panNumber: false,
      });
      setNextSectionError("");
      remitterPersonalDetailApi();
    }
  };

  const handleBlur = (e) => {
    if (e.target.name === "email") {
      if (ValidateEmail() && email !== "") {
        setIsValid({ ...valid, email: true });
        setEmailError("Enter a valid email such as example@email.com");
      } else {
        setEmailError("");
        setIsValid({ ...valid, email: false });
      }
    } else if (e.target.name === "phoneNumber") {
      if (phoneNumber !== "" && phoneNumber.length < 10) {
        setIsValid({ ...valid, phoneNumber: true });
        setPhoneNoError("Phone Number should be 10 digit.");
      } else {
        setIsValid({ ...valid, phoneNumber: false });
        setPhoneNoError("");
      }
    } else if (e.target.name === "PAN") {
      if (panNumber !== "" && !validatePan(panNumber)) {
        setIsValid({ ...valid, panNumber: true });
        setPanError("Enter a valid panNumber such as IFYTS7685M");
      } else {
        setIsValid({ ...valid, panNumber: false });
        setPanError("");
      }
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "name") {
      setName(e.target.value);
    } else if (e.target.name === "email") {
      setEmail(e.target.value);
    } else if (e.target.name === "phoneNumber") {
      if (phoneNumber.length === 0 && e.target.value === "0") {
        setPhoneNumber("");
      } else if (e.target.value === "" || e.target.value.length <= 10) {
        setPhoneNumber(e.target.value);
      }
    } else if (e.target.name === "PAN") {
      const upperCaseValue = e.target.value.toUpperCase();
      if (e.target.value.length <= 10) setPanNumber(upperCaseValue);
    }
  };

  return (
    <Card className={styles.cardAccount}>
      <Card.Body className={styles.cardBodyAccount}>
        <div className={styles.headingandbutton}>
          <Row className={styles.Title}>Personal Detail</Row>
      <Row>
        <Col md={4}>
          <SignInInput
            name="name"
            label="Full Name"
            placeholder="Enter Full Name"
            type="text"
            value={name}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.name}
            disabled={stepToShowOffline !== 1 || remitterList.length>0}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="email"
            label="Email ID"
            placeholder="Enter Email ID"
            type="text"
            value={email}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            errorMessage={emailError}
            isInvalid={valid.email}
            onBlur={(event) => {
              handleBlur(event);
            }}
            disabled={stepToShowOffline !== 1 || remitterList.length>0}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="phoneNumber"
            label="Phone Number"
            placeholder="Enter Phone Number"
            type="number"
            value={phoneNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.phoneNumber}
            onBlur={(event) => {
              handleBlur(event);
            }}
            errorMessage={phoneNoError}
            showcodediv={true}
            codedivName={"phone"}
            disabled={stepToShowOffline !== 1 || remitterList.length>0}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="PAN"
            label="PAN Number"
            placeholder="Enter PAN number"
            type="text"
            value={panNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            isInvalid={valid.panNumber}
            onBlur={(event) => {
              handleBlur(event);
            }}
            errorMessage={panError}
            disabled={stepToShowOffline !== 1 || remitterList.length>0}
          />
        </Col>
      </Row>
      {stepToShowOffline === 1 && <Row className="pt-3 mt-3">
        <div className={styles.errorState}>{nextSectionError}</div>
        {/* <Col md={3}> */}
        <CommonButton
          title="Next"
          onClick={remitterList.length > 0 ? handleSuccess : checkIfValid}
          loading={loading}
          disabled={loading}
          width={"150px"}
        />
      </Row>}
    </div>
      </Card.Body>
      </Card>
  );
}

export default OfflineRemitterForm;
